import { Request } from './Request';

export interface IGenerateZiplogParams {
  logsUpToDate: number;   // Generates logs from 'logsUpToDate' days back
}

export interface IGenerateZiplogResult {
}

export class GenerateZiplogRequest extends Request<IGenerateZiplogParams, IGenerateZiplogResult> {
  constructor(params: IGenerateZiplogParams) {
    super('generateZiplog', params);
  }
}
